import {
  Box,
  Button,
  Center,
  Flex,
  HStack,
  Input,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast,
  VStack,
} from "@chakra-ui/react";
import { ChangeEvent, useEffect, useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import { FaEllipsisH } from "react-icons/fa";
import { RiSearch2Line } from "react-icons/ri";
import AdminDashboardHeader from "../../components/admin/AdminHeader";
import AdminSidebar from "../../components/admin/AdminSidebar";
import Loading from "../../components/common/Loading";
import AdminHelpers from "../../services/admin/admin.service";
import coursesService from "../../services/courses.service";
import userService from "../../services/user.service";
import { getFullDate, getFullTime } from "../../utils/classOfDegree";

const AdminResults = () => {
  const [loading, setLoading] = useState(true); // loading false for now
  const [reload, setReload] = useState(false);
  const [results, setResults] = useState<any>([]);
  const [filteredResults, setFilteredResults] = useState<any>([]);
  const [isSearchEmpty, setIsSearchEmpty] = useState(false);
  const [sort, setSort] = useState("");
  const toast = useToast();



  useEffect(() => {
    const url = `?sort=${sort}`;
    AdminHelpers.getUploadedResults(url).then((res) => {
      setResults(res.data);
      setFilteredResults(res.data);
      setLoading(false);
    });

  },[sort, reload])


  

  const downloadAdminResult = (
    courseId: number,
    sessionId: number,
    termId: number
  ) => {
    AdminHelpers.downloadAdminResult(courseId, sessionId, termId)
      .then((res) => {
        // setTemplateData(res);
        const staticFilename = "Result Download"; // Replace "your_static_filename" with your desired filename
        const outputFilename = `${staticFilename}.csv`;

        const url = URL.createObjectURL(new Blob([res]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", outputFilename);
        document.body.appendChild(link);
        link.click();

        // Clean up the URL and link
        URL.revokeObjectURL(url);
        document.body.removeChild(link);
        toast({
          title: "Result Download",
          description: "Result downloaded successfully",
          status: "success",
          duration: 2000,
        });
      })
      .catch((err: any) => {
        console.log(err, "okayyyy");
        toast({
          title: "Result Download",
          description: `${err.response.data.message || "No results found"}`,
          status: "error",
          duration: 2000,
        });
      });
  };

  const declineResult = (id: number) => {
    try {
      AdminHelpers.declineResult(id).then((res) => {
        toast({
          title: "Result",
          description: "Result declined successfully",
          status: "success",
        });
        setReload(!reload);
      });
    } catch (e) {
      toast({
        title: "Result",
        description: "Something went wrong try again later",
        status: "error",
      });
    }
  };

  const approveResult = (id: number) => {
    try {
      AdminHelpers.approveResult(id).then((res) => {
        toast({
          title: "Result",
          description: "Result approved successfully",
          status: "success",
        });
        setReload(!reload);
      });
    } catch (e) {
      toast({
        title: "Result",
        description: "Something went wrong try again later",
        status: "error",
      });
    }
  };

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const searchTerm = event.target.value.toLowerCase();
    if (!searchTerm) {
      setFilteredResults(results);
    } else {
      if (results) {
        const filtered = results.filter((each: any) =>
          each.course_name.toLowerCase().includes(searchTerm)
        );
        setFilteredResults(filtered);
        if (filtered && filtered.length > 0) setIsSearchEmpty(false);
        else setIsSearchEmpty(true);
      }
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Flex
          minHeight={"100vh"}
          height={"auto"}
          boxSizing="border-box"
          maxWidth={"100hw"}
        >
          <Box
            width={["3.5rem", "3.5rem", "3.5rem", "20%"]}
            position="relative"
            top="0"
            left="0"
            zIndex="100"
          >
            <AdminSidebar />
          </Box>
          <Box width="100%">
            <AdminDashboardHeader />
            <Box
              pt="30px"
              px={["20px", "30px"]}
              width={"100%"}
              bg="#F9F8F8"
              height={"auto"}
              minHeight={"95vh"}
              maxHeight={"95vh"}
              overflowX={"scroll"}
              className="scroll-hidden"
            >
              <VStack
                justifyContent="space-between"
                alignItems="flex-start"
                py="26px"
                gap="1.5rem"
              >
                <Text color="#2B2B2B" fontWeight="800" fontSize="27px">
                  Uploaded Results
                </Text>
                <HStack gap="1rem" w={"100%"}>
                  <InputGroup
                    color="brand.subtitle"
                    bg="white"
                    width={["90%", "90%", "50%", "30%"]}
                  >
                    <Input
                      height="40px"
                      placeholder="Search results by course/program"
                      onChange={(e) => handleSearchChange(e)}
                      fontSize={12}
                      size="sm"
                    />

                    <InputRightElement
                      pointerEvents="none"
                      children={<RiSearch2Line color="red" size="0.9rem" />}
                    />
                  </InputGroup>
                  <Menu>
                    <MenuButton
                      as={Button}
                      rightIcon={<BsChevronDown />}
                      bg="white"
                      color="#616161"
                      variant={"outline"}
                      size="sm"
                      height={"38px"}
                      fontSize={13}
                      border="1px solid"
                      borderColor="#9E9E9E"
                      borderRadius={"none"}
                    >
                      {/* Sort by name(A-Z) */}
                      {sort === ""
                        ? "Sort by Name"
                        : sort === "asc"
                        ? "Sort by Name (A-Z)"
                        : "Sort by Name (Z-A)"}
                    </MenuButton>
                    <MenuList fontSize={12}>
                      {/* <MenuItem>2022/2023</MenuItem>
                      <MenuItem>2021/2022</MenuItem>
                      <MenuItem>2020/2021</MenuItem>
                      <MenuItem>2019/2020</MenuItem> */}
                      <MenuItem onClick={() => setSort("")}>Default</MenuItem>
                      <MenuItem onClick={() => setSort("asc")}>
                        By Ascending
                      </MenuItem>
                      <MenuItem onClick={() => setSort("desc")}>
                        By Descending
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </HStack>
              </VStack>
              <TableContainer width={"100%"} paddingBottom="1.2rem">
                <Table variant="simple">
                  <Thead>
                    <Tr>
                      <Th>Trainer</Th>
                      <Th>Result Uploaded</Th>
                      <Th>Status</Th>
                      <Th>Uploaded</Th>
                      <Th>Last Modified</Th>
                      <Th>Actions</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {filteredResults?.map((each: any, index: number) => {
                      return (
                        <Box
                          key={index}
                          as="tr"
                          marginBottom={"2px"}
                          background={"white"}
                        >
                          <Td>
                            {each?.trainer_name
                              ? each.trainer_name
                              : "Loading..."}
                          </Td>
                          <Td
                            maxW="200px"
                            overflow="hidden"
                            textOverflow="ellipsis"
                          >
                            {each?.course_name
                              ? each.course_name
                              : "Loading..."}
                          </Td>
                          <Td>
                            {each.is_published === 0 ? (
                              <Box
                                bg="#F79E1B"
                                padding={"6px 10px"}
                                borderRadius={"20px"}
                                width={"fit-content"}
                              >
                                <Text color="white">Pending Review</Text>
                              </Box>
                            ) : each.is_published === 1 ? (
                              <Box
                                bg="#47BD61"
                                padding={"6px 10px"}
                                borderRadius={"20px"}
                                width={"fit-content"}
                              >
                                <Text color="white">Accepted</Text>
                              </Box>
                            ) : (
                              <Box
                                bg="#EC3337"
                                padding={"6px 10px"}
                                borderRadius={"20px"}
                                width={"fit-content"}
                              >
                                <Text color="white">Declined</Text>
                              </Box>
                            )}
                          </Td>
                          <Td>
                            {getFullDate(each.created_at)}{" "}
                            {getFullTime(each.created_at)}
                          </Td>
                          <Td>
                            {getFullDate(each.updated_at)}{" "}
                            {getFullTime(each.updated_at)}
                          </Td>
                          <Td>
                            <Menu>
                              <MenuButton
                                // as={Center}
                                cursor="pointer"
                                border="1px solid"
                                borderRadius="10px"
                                borderColor="#E5E5E5"
                                paddingX="10px"
                                height="30px"
                                title="view actions"
                                display={"flex"}
                                justifyContent={"center"}
                                alignItems={"center"}
                                margin={"0 auto"}
                              >
                                <Center>
                                  <FaEllipsisH
                                    color="#757575"
                                    width={"100%"}
                                    height={"100%"}
                                    display={"contents"}
                                  />
                                </Center>
                              </MenuButton>
                              <MenuList>
                                {each.is_published === 1 ? (
                                  <>
                                    <MenuItem
                                      onClick={() => {
                                        downloadAdminResult(
                                          each.course_id,
                                          each.course_session_id,
                                          each.course_term_id
                                        );
                                      }}
                                    >
                                      Download Result (csv)
                                    </MenuItem>
                                    <MenuItem
                                      onClick={() => {
                                        declineResult(each.id);
                                      }}
                                    >
                                      Change Status to “Declined”
                                    </MenuItem>
                                  </>
                                ) : each.is_published === 2 ? (
                                  <>
                                    <MenuItem
                                      onClick={() => {
                                        downloadAdminResult(
                                          each.course_id,
                                          each.course_session_id,
                                          each.course_term_id
                                        );
                                      }}
                                    >
                                      Download Result (csv)
                                    </MenuItem>
                                    <MenuItem
                                      onClick={() => {
                                        approveResult(each.id);
                                      }}
                                    >
                                      Change Status to “Accepted”
                                    </MenuItem>
                                  </>
                                ) : (
                                  <>
                                    <MenuItem
                                      onClick={() => {
                                        downloadAdminResult(
                                          each.course_id,
                                          each.course_session_id,
                                          each.course_term_id
                                        );
                                      }}
                                    >
                                      Download Result (csv)
                                    </MenuItem>
                                    <MenuItem
                                      onClick={() => {
                                        approveResult(each.id);
                                      }}
                                    >
                                      Change Status to “Accepted”
                                    </MenuItem>
                                    <MenuItem
                                      onClick={() => {
                                        declineResult(each.id);
                                      }}
                                    >
                                      Change Status to “Declined”
                                    </MenuItem>
                                  </>
                                )}
                              </MenuList>
                            </Menu>
                          </Td>
                        </Box>
                      );
                    })}
                  </Tbody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </Flex>
      )}
    </>
  );
};

export default AdminResults;
